import { TextField, TextFieldProps } from '@mui/material'
import { useSnackbar } from 'notistack'
import { ChangeEvent, KeyboardEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']

export const NumericAutocompleteInput = (props: TextFieldProps) => {
  const { t } = useTranslation('@cibo/landmanager/FarmInfo')
  const { enqueueSnackbar } = useSnackbar()

  const { onChange, inputProps, ...rest } = props

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event) // still pass through
    },
    [onChange]
  )

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      const isDigit = /^[0-9]$/.test(event.key)

      if (!isDigit && !allowedKeys.includes(event.key)) {
        event.preventDefault()

        enqueueSnackbar(t('useValidNumber'), {
          variant: 'warning',
        })
      }

      inputProps?.onKeyDown?.(event) // still pass to Autocomplete internals
    },
    [enqueueSnackbar, inputProps]
  )

  return (
    <TextField
      {...rest}
      inputProps={{
        ...inputProps,
        inputMode: 'numeric',
        onKeyDown: handleKeyDown,
      }}
      onChange={handleInputChange}
    />
  )
}
